import createReactComponent from "../createReactComponent";
import defaultAttributes from "../defaultAttributes";
var Tag = createReactComponent("Tag", ["svg", defaultAttributes, [["path", {
  d: "M20.59 13.41l-7.17 7.17a2 2 0 01-2.83 0L2 12V2h10l8.59 8.59a2 2 0 010 2.82z",
  key: "55nqjy"
}], ["line", {
  x1: "7",
  y1: "7",
  x2: "7.01",
  y2: "7",
  key: "xebodb"
}]]]);
export default Tag;